(() => {
  const root = document.querySelector(".campaign-main-product");
  const currencySymbol = root?.dataset.currency || "";
  const currencyCode = root?.dataset.currencyCode || "";

  const parseMoney = (value) => {
    const raw = String(value || "").split(currencySymbol).join("").trim();
    if (raw.includes(",") && raw.includes(".")) {
      if (raw.lastIndexOf(",") > raw.lastIndexOf(".")) {
        return Number(raw.replace(/\./g, "").replace(",", "."));
      }
      return Number(raw.replace(/,/g, ""));
    }
    if (raw.includes(",")) {
      return Number(raw.replace(",", "."));
    }
    return Number(raw);
  };

  //switch product's variants
  $('.campaign-main-product .variant-item').click(function () {
    var vid = $(this).attr('data-id');
    var vindex = $(this).attr('data-index');
    var pid = $(this).attr('data-pid');
    $(this).addClass('active').siblings().removeClass('active');
    $('.campaign-main-product .variant-wrapper[data-id=' + vid + ']')
      .addClass('active')
      .siblings()
      .removeClass('active');
    $('.campaign-main-product .variant-img[data-index=' + vindex + '][data-pid=' + pid + ']')
      .addClass('active')
      .siblings()
      .removeClass('active');

    $(
      '.campaign-main-product .buy-card .price[data-index=' +
        vindex +
        '][data-pid=' +
        pid +
        ']'
    )
      .addClass('active')
      .siblings()
      .removeClass('active');
  });

  // 阻止跳转加购
  $(function () {
    $('.campaign-main-product .add-to-cart-form2').on('submit', function (evt) {
      evt.preventDefault();
      ShopifyAPI.addItemFromForm2(evt.target, ajaxCart.itemAddedCallback, ajaxCart.itemErrorCallback);
    });
  });

  //openmeet 切换控制
  $(".campaign-main-product .openmeet .toggle-product-option-item").click(function(){
    $(this).addClass("active").siblings().removeClass("active");
    var $this = $(this);
    setTimeout(function(){
      //usb-a 和 usb-c 和 no
      var now_product = $this.attr("data-product-handle");
      var now_type = $this.attr("data-option-size");

      $(".campaign-main-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='"+now_product+"']").addClass("active").siblings().removeClass("active");
      
      $(".campaign-main-product ."+now_product+" .color_list li").css("display","none");
      $(".campaign-main-product ."+now_product+" .color_list li[data-option2='"+now_type+"']").css("display","block");
      var v_id = $(".campaign-main-product ."+now_product+" .color_list li[data-option2='"+now_type+"']").eq(0).attr("data-var_id");
      $(".campaign-main-product ."+now_product+" .color_list li[data-option2='"+now_type+"'][data-var_id='"+v_id+"']").click();
      
    },100);
  });

  //opencomm2uc2025upgrade 切换控制
  $(".campaign-main-product .opencomm2uc2025upgrade .toggle-product-option-item").click(function(){
    $(this).addClass("active").siblings().removeClass("active");
    var $this = $(this);
    setTimeout(function(){
      //usb-a 和 usb-c
      var now_product = $this.attr("data-product-handle");
      var now_type = $this.attr("data-option-size");
    
      $(".campaign-main-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='"+now_product+"']").addClass("active").siblings().removeClass("active");
      
      $(".campaign-main-product ."+now_product+" .color_list li").css("display","none");
      $(".campaign-main-product ."+now_product+" .color_list li[data-option2='"+now_type+"']").css("display","block");
      var v_id = $(".campaign-main-product ."+now_product+" .color_list li[data-option2='"+now_type+"']").eq(0).attr("data-var_id");
      $(".campaign-main-product ."+now_product+" .color_list li[data-option2='"+now_type+"'][data-var_id='"+v_id+"']").click();
      
    },100);
  });

  //openrun size 切换控制
  $(".campaign-main-product .openrun .toggle-product-option-item").click(function(){
    $(this).addClass("active").siblings().removeClass("active");
    var $this = $(this);
    setTimeout(function(){
      //mini standard
      if($this.hasClass("toggle-product-size-item")){
        var now_product = $this.attr("data-product-handle");
        var now_size = $this.attr("data-option-size");
        var now_type = $(`.campaign-main-product .${now_product} .charger-port-part .toggle-product-option-item.active`).attr("data-option-size");
      }else{ //usb-c 和 磁吸
        var now_product = $this.attr("data-product-handle");
        var now_size = $(`.campaign-main-product .${now_product} .toggle-product-option-size .toggle-product-option-item.active`).attr("data-option-size");
        var now_type = $this.attr("data-option-size");
      }
      $(".campaign-main-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='"+now_product+"'][data-option-size='"+now_size+"']").addClass("active").siblings().removeClass("active");
      
      $(".campaign-main-product ."+now_product+" .color_list li").css("display","none");
      $(".campaign-main-product ."+now_product+" .color_list li[data-option-size='"+now_size+"'][data-option2='"+now_type+"']").css("display","block");
      var v_id = $(".campaign-main-product ."+now_product+" .color_list li[data-option-size='"+now_size+"'][data-option2='"+now_type+"']").eq(0).attr("data-var_id");
      $(".campaign-main-product ."+now_product+" .color_list li[data-option-size='"+now_size+"'][data-option2='"+now_type+"'][data-var_id='"+v_id+"']").click();
      
    },100);
  });

  //Openrun pro2 mini产品切换
  $(".campaign-main-product .openrun-pro2 .toggle-product-option-item").click(function(){
    $(this).addClass("active").siblings().removeClass("active");
    var $this = $(this);
    setTimeout(function(){
      //mini standard
      var now_product = $this.attr("data-product-handle");
      var now_size = $this.attr("data-option-size");
      $(".campaign-main-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='"+now_product+"'][data-option-size='"+now_size+"']").addClass("active").siblings().removeClass("active");
      
      $(".campaign-main-product ."+now_product+" .color_list li").css("display","none");
      $(".campaign-main-product ."+now_product+" .color_list li[data-option-size='"+now_size+"']").css("display","block");
      var v_id = $(".campaign-main-product ."+now_product+" .color_list li[data-option-size='"+now_size+"']").eq(0).attr("data-var_id");
      $(".campaign-main-product ."+now_product+" .color_list li[data-option-size='"+now_size+"'][data-var_id='"+v_id+"']").click();
      
    },100);
  });


  var record_export_collection = new Set();
  var time_interval_home_product_list = -1;
  var home_product_list_attr = [];
  function home_product_ga4_deal_list(collection){
    clearInterval(time_interval_home_product_list);
    let groupedItems = {}; // 用于存储按 item_list_id 分组的商品数组
    let collection_item='';
    collection.forEach((element,index) => {
      collection_item = element.split("::");
      let $v_item_name ='';
      let $v_item_variant ='';
      let $v_item_category ='';
      let $v_item_category2 ='Standard';
      if (product_handle_map.has(collection_item[0])) {
        $v_item_name = product_handle_valueMap[collection_item[0]][0];
        $v_item_variant = product_handle_valueMap[collection_item[0]][1];
        $v_item_category = product_handle_valueMap[collection_item[0]][2];
        $v_item_category2 = product_handle_valueMap[collection_item[0]][3];
      }
      
      let arr_item = {
        "item_id":collection_item[0],
        "item_name":$v_item_name,
        "index":collection_item[2],
        "item_list_id":collection_item[4],
        "item_list_name":collection_item[4],
        "item_category":$v_item_category,
        "item_category2":$v_item_category2,
        "item_category3":collection_item[6].replace("Default Title", "none"),
        "item_variant":$v_item_variant,
        "item_brand":"SHOKZ",
        "price":parseMoney(collection_item[9]),
        "quantity":Number(collection_item[10]),
        "currency":currencyCode,
      }
      // 根据 item_list_name 分组商品
      if (!groupedItems[collection_item[4].split(' ').join('')]) {
          groupedItems[collection_item[4].split(' ').join('')] = []; // 如果没有该组，初始化为空数组
      }
      groupedItems[collection_item[4].split(' ').join('')].push(arr_item); // 将当前商品添加到对应的组中
    });

    // 遍历分组并触发 dataLayer.push
    for (const itemListId in groupedItems) {
      if (groupedItems.hasOwnProperty(itemListId)) {
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
          "event": "ga4Event",
          "event_name": "view_item_list",
          "event_parameters": {
            "currency": currencyCode,
            "item_list_id":groupedItems[itemListId][0]["item_list_name"],
            "item_list_name":groupedItems[itemListId][0]["item_list_name"],
            "items": groupedItems[itemListId] // 推送当前 item_list_name 对应的商品数组
          }
        });
      }
    }
  }

  // 创建一个 Intersection Observer 实例
  var observer_home_product = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 在这里可以添加埋点逻辑
      let product_item = $(entry.target).eq(0).find(".product-data-div").attr("data-product-data");
      let product_item2 = $(entry.target).eq(0).find(".product-data-div").attr("data-product-data");

        product_item = product_item.split("::");
        let product_item_record = product_item[3]+product_item[8];
        product_item_record = product_item_record.split(" ").join("-");

        if(!record_export_collection.has(product_item_record)){
          record_export_collection.add(product_item_record);
          // home_product_ga4_deal(product_item,"","view_item_list")
          home_product_list_attr.push(product_item2);
          clearInterval(time_interval_home_product_list);
          time_interval_home_product_list = setInterval(function(){
            clearInterval(time_interval_home_product_list);
            home_product_ga4_deal_list(home_product_list_attr);
            home_product_list_attr = [];
          },3000);
        }
        // 例如，发送曝光事件到服务器
        observer_home_product.unobserve(entry.target); // 可选：如果只需要一次曝光，可以取消观察
      }
    });
  });

  // 选择要观察的元素
  var targetElements_home_product = document.querySelectorAll('.campaign-main-product .buy-card');
  targetElements_home_product.forEach(element => {
    observer_home_product.observe(element); // 开始观察每个元素
  });

  function page_product_ga4_deal(product_item,buttom_name,event_name,discount = 0){

    let $v_item_name ='';
    let $v_item_variant ='';
    let $v_item_category ='';
    let $v_item_category2 ='Standard';
    if (product_handle_map.has(product_item[0])) {
      $v_item_name = product_handle_valueMap[product_item[0]][0];
      $v_item_variant = product_handle_valueMap[product_item[0]][1];
      $v_item_category = product_handle_valueMap[product_item[0]][2];
      $v_item_category2 = product_handle_valueMap[product_item[0]][3];
    }

    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event":"ga4Event",
      "event_name":event_name,
      "event_parameters":{
        "item_list_id":product_item[4],
        "item_list_name":product_item[4],
        "currency":currencyCode,
        "button_name":buttom_name,
        "items": [
          {
          "item_id":product_item[0],
          "item_name":$v_item_name,
          "index":1,
          "item_list_id":product_item[4],
          "item_list_name":product_item[4],
          "item_category":$v_item_category,
          "item_category2":$v_item_category2,
          "item_category3":product_item[6].replace("Default Title", "none"),
          "item_variant":$v_item_variant,
          "item_brand":"SHOKZ",
          "price":parseMoney(product_item[9]),
          "quantity":Number(product_item[10]),
          "currency":currencyCode,
          "discount": discount
          }
        ]
      }
    });
  };

  function getDiscount($trigger) {
     const $buyCard = $trigger.closest('.buy-card');
    const priceText = $buyCard
      .find('.price.active')
      .clone()
      .children()
      .remove()
      .end()
      .text();

    const compareText = $buyCard
      .find('.price.active .tag_sale-compare-price')
      .text();

    const price = parseMoney(priceText) || 0;
    const compare_at_price = parseMoney(compareText) || 0;

    const discount = compare_at_price > price ? +(compare_at_price - price).toFixed(2) : 0;
    return discount;
  }

  $(".campaign-main-product .buy-card .variant-buttons .addtocart").click(function(){
    let product_item = $(this).attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(product_item,$(this).text().trim(),"add_to_cart",getDiscount($(this)));
  });

  $(".campaign-main-product .buy-card .product-link").click(function(){
    let product_item = $(this).parent().parent().find(".product-data-div").attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(product_item,"Product link","select_item",getDiscount($(this)));
  });

  $(".campaign-main-product .buy-card .product-title").click(function(){
    let product_item = $(this).parent().parent().parent().find(".product-data-div").attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(product_item,"Product title","select_item",getDiscount($(this)));
  });

  $(".campaign-main-product .buy-card .variants-img-wrapper").click(function(){
    let product_item = $(this).find(".product-img.active").attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(product_item,"Product Image link","select_item",getDiscount($(this)));
  })

  $(".campaign-main-product .product-box .poster-link").click(function(){
    const $card = $(this).closest('.product-box'); 
    let product_item = $card.find(".buy-card .variants-img-wrapper .product-img.active").attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(product_item,"Product Poster link","select_item",getDiscount($(this)));
  })
})();
